module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/fonts/basis_grotesque_regular-af6d1c9fcd2934c7187bae73f4001e42.woff";